import { render, staticRenderFns } from "./ItemHoverButtons.vue?vue&type=template&id=2f85647b&"
import script from "./ItemHoverButtons.vue?vue&type=script&lang=js&"
export * from "./ItemHoverButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports